import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ICON } from "../../../assets/images";
import { Button, Card, Dropdown, Modal } from "react-bootstrap";
import {
  toggleAction,
  toggleActionSuccess,
  userWiseAuctionCenterDetails,
  getServerDateAndTimeAction,
  getServerDateAndTimeSuccess,
  fetchTokenRequest,
  logoutAccout,
  logoutRequest,
  toggleActionFail
} from "../../../store/actions";
import { useNavigate, useLocation } from "react-router-dom";
import ChangePwd from "../../../pages/ChangePwd/ChangePwd";
import CustomToast from "../../Toast";
import { AiOutlineClose } from "react-icons/ai";
import axiosMain from "../../../http/axios/axios_main";
import SockJS from "sockjs-client";
import Stomp from "stompjs";
import EmailNotificationModule from "../../../pages/emailNotification/EmailNotificationModule";
import { useAuctionDetail } from "../../common/AunctioneerDeteailProvider";
import Cookies from 'js-cookie';
let serverDateAndTimeValue = new Date();
let count = 1;
let auctionTypeCheck = process.env.REACT_APP_END_POINT_URL_IS_AUCTION_TYPE;
const TokenUpdateModal = ({ show, onClose, onConfirm }) => {
  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header>
        <Modal.Title>Update Session</Modal.Title>
        <i className="fa fa-times CloseModal" onClick={() => onClose()}></i>
      </Modal.Header>

      <p className="BtnGroup pt-3 pl-3">
        Your session will expire in 5 Minutes. Please update your session?
      </p>
      <div className="BtnGroup pb-3 pl-3">
        <button class="SubmitBtn mt-0" onClick={onClose}>
          No
        </button>
        <button class="SubmitBtn mt-0" onClick={onConfirm}>
          Yes
        </button>
      </div>
    </Modal>
  );
};
const HeaderUI = () => {
  const activeClass = useSelector((state) => state.toggle.activeClass);
  const updatedRefreshCdes = useSelector((state) => state.auth);
  const {
    auctionDetailId,
    auctionCenterUserId,
    auctionCenterId,
    userId,
    auction,
    roleCode,
    auctionTypeMasterCode,
    userCode,
    auctionTypeMasterId,
    roleId,
  } = useAuctionDetail();
  const isLoggingOut = useSelector(state => state?.auth?.isLoggingOut);

  const isLoggedOut = useSelector(state => state?.auth?.isLoggedOut);
useEffect(() => {
  if (isLoggedOut) {
    localStorage.clear();
    sessionStorage.removeItem("argument1");
    sessionStorage.removeItem("argument2");
    sessionStorage.removeItem("argument3");
    sessionStorage.removeItem("argument4");
    sessionStorage.removeItem("argument5");
    sessionStorage.removeItem("argument6");
    sessionStorage.removeItem("argument7");
    sessionStorage.removeItem("argument12");
    // document.cookie =
    //   "token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    clearAllCookies();
    sessionStorage.clear();
    // Perform logout action
    // navigate("/login");
    window.location.href = "/login";
    logoutAccout();
    setShowModal(false);
  }
}, [isLoggedOut]);
  const dispatch = useDispatch();
  const [time, setTime] = useState(serverDateAndTimeValue);
  const [showModal, setShowModal] = useState(false);
  const [modalNames, setModalNames] = useState(false);
  const navigate = useNavigate();
  const [auctionCenterValue, setAuctionCenterValue] = useState("");
  const [showModal1, setShowModal1] = useState(false);
  const [variableValue, setVariableValue] = useState(false);
  const [openEmailNotification, setOpenEmailNotification] = useState(false);
  const location = useLocation();
  const currentPath = location.pathname;
  const options = {
    timeZone: "Asia/Kolkata",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    hourCycle: 'h23', 
    minute: "2-digit",
    second: "numeric",
  };
  const handleButtonClick = () => {
    setModalNames(true);
  };
  let indianTime = time.toLocaleString("en-IN", options);

  const auctionCenterDropDownAllData = useSelector(
    (state) => state?.auctionCenter?.userWiseAuctionCenterDetails?.responseData
  );

  const auctionCenterDropDownMappedData =
    auctionCenterDropDownAllData &&
    auctionCenterDropDownAllData.filter((data) => 1 == data.mapped && data.auctionTypeMasterId == auctionTypeCheck);

  useEffect(() => {
    const keysToRetrieve = [
      "argument1",
      "argument2",
      "argument3",
      "argument4",
      "argument5",
      "argument6",
      "argument7",
      "argument11",
      "argument12",
    ];

    // Iterate through keys and retrieve their corresponding values
    keysToRetrieve.map((key) => {
      // const value =
      sessionStorage.setItem(key, localStorage.getItem(key));
      // return { key, value };
    });
    // dispatch(getServerDateAndTimeAction());
    // const timer = setInterval(() => {
    //   let tempDate = new Date(serverDateAndTimeValue);
    //   tempDate.setSeconds(tempDate.getSeconds() + count++);
    //   setTime(tempDate);
    // }, 1000);

    // return () => {
    //   clearInterval(timer);
    // };
  }, []);

  useEffect(() => {
    let payloadData = {
      userId: atob(sessionStorage.getItem("argument2")),
    };

    if (
      auctionCenterDropDownMappedData == undefined &&
      "/dashboard" != currentPath
    ) {
      dispatch(userWiseAuctionCenterDetails(payloadData));
    }

    let tempData =
      window.location.pathname &&
      window.location.pathname.split("/") &&
      window.location.pathname.split("/")[4];
    let auctionCenterId = tempData && atob(tempData);
    setAuctionCenterValue(auctionCenterId);
  });

  const serverDateAndTime = useSelector(
    (state) => state?.auctionCenter?.serverDateAndTime?.responseData
  );

  useEffect(() => {
    // if (serverDateAndTime != null || serverDateAndTime != undefined) {
    //   let serverDateAndTimeTemp = new Date(serverDateAndTime);

    //   let date = new Date();
    //   date.setDate(serverDateAndTimeTemp.getDate());
    //   date.setHours(serverDateAndTimeTemp.getHours());
    //   date.setMinutes(serverDateAndTimeTemp.getMinutes());
    //   date.setSeconds(serverDateAndTimeTemp.getSeconds());

    //   serverDateAndTimeValue = date;
    //   setTime(date);
    //   indianTime = date?.toLocaleString("en-IN", options);

    //   dispatch(getServerDateAndTimeSuccess(null));
    // }
    // if (localStorage.getItem("expireLoggedTokenTime") === "Closed") {
    //   setShowModal1(false);
    // }
    if (localStorage.length === 2) {
      // logoutAccout();
      sessionStorage.clear();
      window.location.href = "/login";
    }
  });

  const handleCloseHistory = () => setModalNames(false);
  // const formatTime = (time) => {
  //   const options = { hour: "numeric", minute: "numeric", second: "numeric" };
  //   const formattedTime = time.toLocaleTimeString("en-IN", options);
  //   return formattedTime;
  // };

  const handleClick = () => {
    dispatch(toggleActionSuccess());
  };
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      window.location.reload();
    };

    const handleOffline = () => {
      setIsOnline(false);
      alert('Internet connection lost!');
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);
  useEffect(() => {
    socketHandler();
  }, []);

  const socketHandler = () => {
    let url =
      process.env.NODE_ENV === "development"
        ? process.env.REACT_APP_END_POINT_URL_DEV
        : process.env.REACT_APP_END_POINT_URL_PROD;

    // Connect to the server using SockJS
    const socket = new SockJS(
      url + "/admin/connect?token=" + atob(sessionStorage.getItem("argument1"))
    );

    // Create a Stomp.js client over the WebSocket connection
    const stompClient = Stomp.over(socket);
    stompClient.debug = null;
    const subscribeToGetDate = () => {
      stompClient.subscribe("/admin/broadcast/greetings", (message) => {
        if (message.body) {
          let serverDateAndTimeTemp = new Date(message.body);

          let date = new Date();
          date.setDate(serverDateAndTimeTemp.getDate());
          date.setHours(serverDateAndTimeTemp.getHours());
          date.setMinutes(serverDateAndTimeTemp.getMinutes());
          date.setSeconds(serverDateAndTimeTemp.getSeconds());

          serverDateAndTimeValue = date;
          setTime(date);
          indianTime = date?.toLocaleString("en-IN", options);
        }
      });
    };

    // Connect to the WebSocket server
    stompClient.connect({}, () => {
      console.log("Connected to WebSocket server");
      subscribeToGetDate();
    });
  };

  const dropDownOnChange = (event) => {
    let tempData = event.target.options[event.target.selectedIndex].id;
    let auctionCenterId = event.target.value;
    let auctionDetailId =
      tempData && tempData.split(",") && tempData.split(",")[0];
    let auctionCenterUserId =
      tempData && tempData.split(",") && tempData.split(",")[1];
    let auctionTypeMasterId =
      tempData && tempData.split(",") && tempData.split(",")[2];

    let url = `/auctionPage/${btoa(auctionDetailId)}/${btoa(
      auctionCenterUserId
    )}/${btoa(auctionCenterId)}/${btoa(auctionTypeMasterId)}`;
    //navigate(url);
    window.open(url);
    setAuctionCenterValue(auctionCenterId);
    window.location.reload();
  };

  const handleLogout = () => {
    // Display the modal
    setShowModal(true);
  };

  const clearAllCookies = () => {
    // Set expiration date in the past to delete cookies
    Cookies.remove('argument1', { path: '/' });
    document.cookie.split(";").forEach((cookie) => {
      document.cookie = cookie.replace(/^ +/, "");
    });
    // Optional: Inform the user that cookies have been cleared
    // alert("Cookies have been cleared");
  };

  const handleConfirmation = (confirmed) => {
    // If user confirms, proceed with logout
    if (confirmed) {
      if (activeClass) {
        dispatch(toggleActionSuccess());
      }
      dispatch(logoutRequest());
    }else{
      setShowModal(false);
    }
  };

  // useEffect(() => {
  //   if (!showModal1 && variableValue) {
  //     setTimeout(() => {
  //       CustomToast.error("Token is Expired.");
  //       sessionStorage.clear();
  //       localStorage.clear();
  //       navigate("/login");
  //     }, 1000000);
  //   }
  // }, [showModal1]);
  function getCookie(name) {
    // Split cookies by semicolon
    const cookiess = document.cookie.split(";");

    // Loop through each cookie to find the one with the specified name
    for (let i = 0; i < cookiess.length; i++) {
      let cookie = cookiess[i].trim();
      // Check if the cookie starts with the specified name
      if (cookie.startsWith(name + "=")) {
        // Return the substring after the cookie name
        return cookie.substring(name.length + 1);
      }
    }
    // Return null if the cookie is not found
    return null;
  }
  const handleStorageChange = (event) => {
    if (event.key === "logoutEvent") {
      // If logout event received, clear authentication token and update state
      // setAuthToken('');
      sessionStorage.clear();
    }
  };

  useEffect(() => {
    const checkAndUpdateToken = () => {
      const argument11 = localStorage.getItem("argument12");
      const currentTime = new Date();
      const token = getCookie("token");

      if (
        localStorage.getItem("argument1") !== null &&
        localStorage.getItem("expireLoggedTokenTime") !== "Closed"
      ) {
        const timeExpired = atob(argument11);
        const argument11Time = new Date(timeExpired); // Convert token expiration time to Date object

        let totalSecondsRemaining;

        // Calculate total seconds remaining until token expiration time
        if (argument11Time > currentTime) {
          // Token expiration time is in the future
          const timeDiffInSeconds = Math.floor(
            (argument11Time - currentTime) / 1000
          );
          totalSecondsRemaining = timeDiffInSeconds;
          // console.log(totalSecondsRemaining, "totalSecondsRemaining1"); main timer that consolle all time
        } else {
          // Token expiration time has already passed today, adjust for tomorrow
          const tomorrow = new Date(currentTime);
          tomorrow.setDate(tomorrow.getDate() + 1); // Move to the next day
          const tomorrowMidnight = new Date(
            tomorrow.getFullYear(),
            tomorrow.getMonth(),
            tomorrow.getDate()
          );
          const midnightDiffInSeconds = Math.floor(
            (tomorrowMidnight - currentTime) / 1000
          );
          totalSecondsRemaining = midnightDiffInSeconds;
        }

        // Continue with your token expiration logic here...
        if (totalSecondsRemaining === 300) {
          setShowModal1(true);
          localStorage.setItem("expireLoggedTokenStatus", "active");
        }
        if (totalSecondsRemaining <= 0) {
          // Logout if token expiration time has passed
          CustomToast.error("Session is Expired.");
          if (activeClass) {
            dispatch(toggleActionSuccess());
          }
          dispatch(toggleActionFail())
          // debugger;
          sessionStorage.clear();
          localStorage.clear();
          document.cookie =
            "token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
          navigate("/login");
          logoutAccout();
        }
      } else {
        // debugger;
        setShowModal1(false);
        CustomToast.error("Session is Expired.");
        if (activeClass) {
          dispatch(toggleActionSuccess());
        }
        sessionStorage.clear();
        localStorage.clear();
        document.cookie =
          "token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        navigate("/login");
        // Add event listener when component mounts
        window.addEventListener("storage", handleStorageChange);

        // Clean up event listener when component unmounts
        return () => {
          window.removeEventListener("storage", handleStorageChange);
        };
      }
    };

    const tokenCheckInterval = setInterval(() => {
      if (localStorage.getItem("expireLoggedTokenStatus") === "inactive") {
        // setVariableValue(localStorage.getItem("expireLoggedTokenTime"));
        setShowModal1(false);
        checkAndUpdateToken();

        // localStorage.removeItem("expireLoggedTokenTime");
      } else {
        checkAndUpdateToken();
      }
    }, 1000);

    // Clear the interval when the component unmounts or when the effect re-runs
    return () => clearInterval(tokenCheckInterval);
  }, []); // Dependency array is empty, so this effect runs only once after the initial render

  // const handleUpdateToken = () => {
  //   const userCode = sessionStorage.getItem("argument4");
  //   dispatch(fetchTokenRequest(atob(userCode)));
  //   localStorage.setItem("expireLoggedTokenTime", false);
  //   setShowModal1(false);
  // };
  const handleUpdateToken = async () => {
    const userCode = sessionStorage.getItem("argument4");
    try {
      const updatedRefreshCdes = await dispatch(
        // fetchTokenRequest(atob(userCode))
        axiosMain
          .post("/admin/auth/refreshToken", {
            userCode: atob(userCode),
          })
          .then((res) => {
            const newToken = res.data?.responseData.token;
            const newTokenExpirationOn =
              res.data?.responseData.tokenExpirationOn;
            if (newToken || newTokenExpirationOn) {
              const newExpData = newTokenExpirationOn;
              const newExpData1 = newToken;
              console.log(
                newToken,
                newTokenExpirationOn,
                newToken || newTokenExpirationOn,
                "argument11Time"
              );
              localStorage.setItem("argument1", btoa(newExpData1));
              localStorage.setItem("argument12", btoa(newExpData));
              localStorage.setItem("expireLoggedTokenStatus", "inactive");
              sessionStorage.setItem("argument1", btoa(newExpData1));
              sessionStorage.setItem("argument12", btoa(newExpData));
            }
          })
      );
      const newToken = updatedRefreshCdes.data.token;
      const newTokenExpirationOn = updatedRefreshCdes.data.tokenExpirationOn;

      // Update sessionStorage with new token and expiration time
      sessionStorage.setItem("argument1", btoa(newToken));
      sessionStorage.setItem("argument12", btoa(newTokenExpirationOn));
    } catch (error) {
      console.error("Error updating token:", error);
      // Handle errors if necessary
    }
    setShowModal1(false);
  };
  useEffect(() => {
    if (
      updatedRefreshCdes &&
      updatedRefreshCdes.data &&
      updatedRefreshCdes.data.length !== 0
    ) {
      const newToken = updatedRefreshCdes.data.token;
      const newTokenExpirationOn = updatedRefreshCdes.data.tokenExpirationOn;
      if (newToken || newTokenExpirationOn) {
        const newExpData = newTokenExpirationOn;
        const newExpData1 = newToken;
        console.log(
          newToken,
          newTokenExpirationOn,
          newToken || newTokenExpirationOn,
          "argument11Time"
        );
        localStorage.setItem("argument1", btoa(newExpData1));
        localStorage.setItem("argument12", btoa(newExpData));
        sessionStorage.setItem("argument1", btoa(newExpData1));
        sessionStorage.setItem("argument12", btoa(newExpData));
      }
    }
  }, [updatedRefreshCdes.data]);

  // const handleUpdateToken = async () => {
  //   const userCode = sessionStorage.getItem("argument4");

  //   try {
  //     const updatedRefreshCdes = await dispatch(fetchTokenRequest(atob(userCode)));

  //     // Assuming `updatedRefreshCdes.data.token` and `updatedRefreshCdes.data.tokenExpirationOn` exist
  //     const newToken = updatedRefreshCdes.data.token;
  //     const newTokenExpirationOn = updatedRefreshCdes.data.tokenExpirationOn;

  //     // Update sessionStorage with new values
  //     sessionStorage.setItem("argument1", newToken);
  //     sessionStorage.setItem("argument11", newTokenExpirationOn);

  //     // Close the modal
  //     setShowModal1(false);
  //   } catch (error) {
  //     console.error("Error updating token:", error);
  //     // Handle errors if necessary
  //   }
  // };
  const handleEmailNotificationClick = () => {
    setOpenEmailNotification(true);
  };

  const handleCloseModal = () => {
    setShowModal1(false);
    localStorage.setItem("expireLoggedTokenStatus", "inactive");
    if (activeClass) {
      dispatch(toggleActionSuccess());
    }
    // handleConfirmation(true);
  };
  return (
    <>
      <header className={activeClass ? "active" : ""}>
        <nav className="navbar navbar-expand-lg">
          <div className="container-fluid">
            <div className="row justify-content-between w-100 align-items-center">
              <div className="col-lg-3 col-md-4 d-md-flex align-items-center">
                {sessionStorage.getItem("isLogged") === "1" ? (
                  ""
                ) : (
                  <>
                    {"/dashboard" != currentPath ? (
                      <span onClick={handleClick} className="SidebarToggle">
                        <i
                          className={activeClass ? "fa fa-times" : "fa fa-bars"}
                        ></i>
                      </span>
                    ) : (
                      ""
                    )}
                  </>
                )}
                <div className="LogoTitle mx-3">
                  <a className="navbar-brand" href="index.html">
                    <img src={ICON} className="img-fluid Logo" alt="Logo" />
                  </a>
                  <h2>Teaboard Auction</h2>
                </div>
              </div>
              <div className="col-lg-9  col-md-8">
                <div className="row justify-content-end align-items-center">
                  {isOnline ? (
                  <>
                  {"/dashboard" != currentPath ? (
                    <div className="col-auto">
                      <div className="FormGroup Auction-center-list">
                        <select
                          className="form-control select-form mb-0"
                          value={auctionCenterValue}
                          onChange={(e) => dropDownOnChange(e)}
                        >
                          {auctionCenterDropDownMappedData?.map((state) => (
                            <option
                              id={
                                state.liveSessionDetail != null &&
                                state.liveSessionDetail != undefined &&
                                state.liveSessionDetail.length > 0
                                  ? state.liveSessionDetail[0].auctionDetailId +
                                    "," +
                                    state.auctionCenterUserId +
                                    "," +
                                    state.auctionTypeMasterId
                                  : 0 +
                                    "," +
                                    state.auctionCenterUserId +
                                    "," +
                                    state.auctionTypeMasterId
                              }
                              value={state.auctionCenterId}
                            >
                              {state.auctionCenterName}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  </>) : " You are offline. Please check your internet connection."
                  }
                  <div className="col-auto">
                    <span className="Timer">
                      <i className="fa fa-clock" aria-hidden="true"></i>
                      {indianTime}
                    </span>
                  </div>

                  {/* <span>
              <b>Season :</b> 2023
            </span>{" "}
            <span className="divider"></span>{" "}
            <span>
              <b>Sale No :</b> 25
            </span>{" "}
            <span className="divider"></span>{" "}
            <span>
              <b>Auction Date :</b> 03-07-2023
            </span>{" "}
            <span className="divider"></span>
            */}
                  {/* <div className="col-auto">
                    <span className="UserName">
                      <b> Welcome </b> &nbsp;
                      {atob(sessionStorage.getItem("argument5"))}{" "}
                      {atob(sessionStorage.getItem("argument6"))}
                    </span>{" "}
                  </div> */}
                  {/* <div className="col-auto">
                    <button className="UserName" onClick={handleButtonClick}>
                      Change Password
                    </button>
                  </div> */}

                  {/* <div className="col-auto">
                    <button
                      className="LogoutBtn"
                      onClick={handleLogout}
                      // onClick={() => {
                      //   sessionStorage.removeItem("argument1");
                      //   sessionStorage.removeItem("argument2");
                      //   sessionStorage.removeItem("argument3");
                      //   sessionStorage.removeItem("argument4");
                      //   sessionStorage.removeItem("argument5");
                      //   sessionStorage.removeItem("argument6");
                      //   sessionStorage.removeItem("argument7");

                      //   navigate("/login");
                      // }}
                    >
                      Sign Out
                    </button>
                  </div> */}
                  <div className="col-auto">
                    <Dropdown>
                      <Dropdown.Toggle className="DropDownBox">
                        <>
                          <span className="UserName">
                            <b> Welcome </b> &nbsp;
                            {atob(sessionStorage.getItem("argument5"))}{" "}
                            {atob(sessionStorage.getItem("argument6"))}
                          </span>{" "}
                        </>
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item onClick={handleButtonClick}>
                          <i className="fa fa-key"></i> Change Password
                        </Dropdown.Item>
                        {!window.location.pathname
                          .split("/")
                          .includes("dashboard") && (
                          <Dropdown.Item onClick={handleEmailNotificationClick}>
                            <i className="fa fa-envelope"></i> Email
                            Notification
                          </Dropdown.Item>
                        )}

                        <Dropdown.Item onClick={handleLogout}>
                          <i className="fa fa-sign-out"></i> Sign Out
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </header>{" "}
      {modalNames && (
        <Modal show={modalNames} onHide={handleCloseHistory} size="md" centered>
          <Modal.Header>
            <Modal.Title>Change Password</Modal.Title>
            <i
              className="fa fa-times CloseModal"
              onClick={handleCloseHistory}
            ></i>
          </Modal.Header>
          <Modal.Body>
            <ChangePwd />
          </Modal.Body>
        </Modal>
      )}
      {showModal && (
        <Modal
          show={showModal}
          onHide={() => setShowModal(false)}
          size="md"
          centered
        >
          <Modal.Header>
            <Modal.Title>Sign Out</Modal.Title>
            <i
              className="fa fa-times CloseModal"
              onClick={() => setShowModal(false)}
            ></i>
          </Modal.Header>
          <Modal.Body className="text-center">
            <h5>Are you sure you want to sign out?</h5>
            <div className="BtnGroup justify-content-center">
              <button
                type="button"
                className="SubmitBtn signOut"
                size="lg"
                disabled={isLoggingOut}
                onClick={() => handleConfirmation(true)}
              >
                YES
              </button>
              &nbsp;&nbsp;
              <button
                type="button"
                className="SubmitBtn signOut"
                size="lg"
                onClick={() => handleConfirmation(false)}
              >
                NO
              </button>
            </div>
          </Modal.Body>
        </Modal>
      )}
      <TokenUpdateModal
        show={showModal1}
        onClose={handleCloseModal}
        onConfirm={handleUpdateToken}
      />
      <EmailNotificationModule
        open={openEmailNotification}
        setOpen={setOpenEmailNotification}
        // modalRight
      />
    </>
  );
};

export default HeaderUI;
